/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const TRAG_LOGO = require("./res/images/trag.png");
export const TRAG_ILLUSTRATION_1 = require("./res/images/trag-i1.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");

export const BANNER_IMAGE = require("./res/images/bg.png");
export const TRAG_LIGHT_LOGO = require("./res/images/trag-2.png");
export const TRAG_ILLUSTRATION = require("./res/images/trag-illustration.png");
export const AUTHENTICITY = require("./res/images/Authenticity.png");
export const TRANSPARENCY = require("./res/images/Transparency.png");
export const EFFICIENCY = require("./res/images/Efficiency.png");
export const CUSTOMER_ENGAGEMENT = require("./res/images/Customer_Engagement.png");
export const PROTECT_B_AND_C = require("./res/images/Protect_brand_and_customer.png");
export const ELEVATE_CE = require("./res/images/Elevate_customer_experience.png");
export const PRODUCT_JOURNEY = require("./res/images/product_journey.png");
export const CARBON_FOOTPRINT = require("./res/images/carbonfp.png");
export const C_CREDITS = require("./res/images/c-credit.png");

export const IMAGES = [
    VLINDER_LOGO,
    TRAG_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,
    TRAG_ILLUSTRATION_1,
    TRAG_ILLUSTRATION,
    AUTHENTICITY,
    TRANSPARENCY,
    EFFICIENCY,
    CUSTOMER_ENGAGEMENT,
    PROTECT_B_AND_C,
    ELEVATE_CE,
    PRODUCT_JOURNEY,
    CARBON_FOOTPRINT,
    C_CREDITS,
];
